import request from "@/utils/request";


// 查询我向服务说句话
// export function getAssessInfo(data) {
//   return request({
//     url: "/ywt/api/assess/getAssessInfo",
//     method: "post",
//     data,
//   });
// }
// 个签接口
export function createsign(data) {
  return request({
    url: "/jpaas-jags-server/interface/createsign",
    method: "post",
    data,
  });
}
export function switchTicket(data) {
  return request({
    url: "/api-gateway/jpaas-jiop-web-server/interface//buttjoint/switchTicket",
    method: "GET",
    data,
  });
}
//查询接口
export function query(data) {
  return request({
    url: "/jpaas-jags-server/interface/gateway",
    method: "post",
    data,
  });
}

